var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { tap, map, exhaustMap, catchError, switchMap, debounceTime } from 'rxjs/operators';
import * as fromRouter from '../../../core/store/actions/router.action';
import { AuthService } from '../../services/auth.service';
import { Login, SilentLogin, LoginSuccess, LoginFailure, AuthActionTypes, LoadUser, LoadUserFail, Logout, LoginSuccessRedirect, AuthReset, ResetUser, Silent } from '../actions';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { ResetSubGroupsState } from '@app/core/store/actions/subGroup.action';
import { ResetCartState } from '@app/pages/cart/store';
import { ResetLayoutState } from '@app/core/store/actions/layout.action';
import { ResetCountriesState } from '@app/core/store/actions/country.action';
import { ResetUserAddressState } from '@app/core/store/actions/user-addresses.action';
import { ResetProductState } from '@app/core/store/actions/product.action';
import { ResetToastState } from '@app/core/store/actions/toast.action';
import { ResetOrdersState } from '@core/store/actions/order.action';
import { ResetSidebarState } from '@core/store/actions/sidebar.action';
import { ResetShowcaseState } from '@pages/dashboard/store';
import { ResetShipping } from '@pages/checkout/store';
import { ResetSearchHistoryState } from '@core/store/actions/search-history.action';
import { ResetLastRouteState } from '@core/store/actions/last-route.action';
import { CachedRequestService } from '@app/core/service/cached-req.service';
export class AuthEffects {
    constructor(actions$, authService, localStorageService, cachedRequestService) {
        this.actions$ = actions$;
        this.authService = authService;
        this.localStorageService = localStorageService;
        this.cachedRequestService = cachedRequestService;
        this.login$ = this.actions$.pipe(ofType(AuthActionTypes.Login), map((action) => action.payload), switchMap((auth) => this.loginImplementation(auth, false)));
        this.silentLogin$ = this.actions$.pipe(ofType(AuthActionTypes.SilentLogin), map((action) => action.payload), switchMap((auth) => this.loginImplementation(auth, true)));
        // @Effect()
        // login$ = this.actions$
        //   .ofType(AuthActions.Login)
        //   .switchMap(action => {
        //     return this.authService
        //       .login(action.payload)
        //       .pipe(
        //         map(() => new LoginSuccessRedirect()),
        //         catchError(error =>
        //           of(new LoginFailure(error.error.non_field_errors))
        //         )
        //       );
        //   });
        this.loginSuccess$ = this.actions$.pipe(ofType(AuthActionTypes.LoginSuccess), switchMap(() => [new LoadUser()]));
        this.loginSuccessNoRedirect$ = this.actions$.pipe(ofType(AuthActionTypes.LoginSuccessRedirect), switchMap(() => [new LoadUser()]));
        this.loginRedirect$ = this.actions$.pipe(ofType(AuthActionTypes.LoginRedirect), map(() => new fromRouter.Go({ path: ['/login'] })));
        this.logout$ = this.actions$.pipe(ofType(AuthActionTypes.Logout), tap(() => {
            this.cachedRequestService.clearItems();
            this.localStorageService.clearItem('tecdoc_options');
            this.localStorageService.clearItem('id_token');
        }), switchMap(() => [
            new LoadUserFail(''),
            // This should preserve current url, simpler solutions is to just not do redirect, and cleared token will do its job
            // new LoginRedirect(),
            new AuthReset(),
            new ResetUser(),
            new ResetCartState(),
            new ResetLayoutState(),
            new ResetSubGroupsState(),
            new ResetCountriesState(),
            new ResetUserAddressState(),
            new ResetProductState(),
            new ResetOrdersState(),
            new ResetShowcaseState(),
            new ResetShipping(),
            new ResetSidebarState(),
            new ResetToastState(),
            new ResetSearchHistoryState(),
            new ResetLastRouteState()
        ]), tap(() => {
            setTimeout(() => {
                window.location.reload();
            });
        }));
        this.silentAuth$ = this.actions$.pipe(ofType(AuthActionTypes.SilentAuth), debounceTime(100), exhaustMap(() => {
            return this.authService.checkToken().pipe(map(() => new LoginSuccess()), catchError(() => {
                return of(new Logout());
            }));
        }));
        this.silentAuthNoAction$ = this.actions$.pipe(ofType(AuthActionTypes.SilentAuthNoAction), debounceTime(100), exhaustMap(() => {
            return this.authService.checkToken(true).pipe(map(() => new LoginSuccess()), catchError(() => {
                return of(new Silent());
            }));
        }));
    }
    loginImplementation(auth, silenced) {
        return this.authService.login(auth, silenced).pipe(map(() => new LoginSuccessRedirect()), catchError(error => of(new LoginFailure(error.error && error.error.non_field_errors))));
    }
}
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "login$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "silentLogin$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "loginSuccess$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "loginSuccessNoRedirect$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "loginRedirect$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "logout$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "silentAuth$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AuthEffects.prototype, "silentAuthNoAction$", void 0);
